/* 
    Dependencies
*/
import { mapGetters } from "vuex";
import firebase from "firebase";
import firestore from "../../config/firebase";

export default {
  name: "ActiveUsers",

  components: {},

  data: () => {
    return {
      activeUsers: []
    };
  },

  props: {
    isPresenter: Boolean,
    webinarId: String
  },

  async mounted() {
    await this.presence();

    await this.currentActiveUsers();
  },

  computed: {
    ...mapGetters(["getUserDetails"])
  },

  methods: {
    async presence() {
      // Fetch the current user's ID from Firebase Authentication.
      try {
        var uid = firebase.auth().currentUser.uid;
      } catch (error) {
        this.$router.push({ name: "TownHall" });
        return;
      }

      // Create a reference to this user's specific status node.
      // This is where we will store data about being online/offline.
      var userStatusDatabaseRef = firebase.database().ref("/status/" + uid);
      var userStatusFirestoreRef = firebase
        .firestore()
        .doc("/WebinarReport/" + this.webinarId + "/Users/" + uid);
      // We'll create two constants which we will write to
      // the Realtime database when this device is offline
      // or online.
      var isOfflineForDatabase = {
        state: "offline",
        last_changed: firebase.database.ServerValue.TIMESTAMP,
        name: this.getUserDetails.userName,
        role: this.getUserDetails.role,
        area: this.getUserDetails.area,
        team: this.getUserDetails.team,
        office: this.getUserDetails.office,
        profileUrl: this.getUserDetails.profileUrl,
        isPresenter: this.isPresenter,
        webinarId: this.webinarId
      };

      var isOnlineForDatabase = {
        state: "online",
        last_changed: firebase.database.ServerValue.TIMESTAMP,
        name: this.getUserDetails.userName,
        role: this.getUserDetails.role,
        area: this.getUserDetails.area,
        team: this.getUserDetails.team,
        office: this.getUserDetails.office,
        profileUrl: this.getUserDetails.profileUrl,
        isPresenter: this.isPresenter,
        webinarId: this.webinarId
      };
      // Firestore uses a different server timestamp value, so we'll
      // create two more constants for Firestore state.
      var isOfflineForFirestore = {
        state: "offline",
        last_changed: firebase.firestore.FieldValue.serverTimestamp(),
        name: this.getUserDetails.userName,
        role: this.getUserDetails.role,
        area: this.getUserDetails.area,
        team: this.getUserDetails.team,
        office: this.getUserDetails.office,
        profileUrl: this.getUserDetails.profileUrl,
        isPresenter: this.isPresenter,
        webinarId: this.webinarId
      };

      var isOnlineForFirestore = {
        state: "online",
        last_changed: firebase.firestore.FieldValue.serverTimestamp(),
        name: this.getUserDetails.userName,
        role: this.getUserDetails.role,
        area: this.getUserDetails.area,
        team: this.getUserDetails.team,
        office: this.getUserDetails.office,
        profileUrl: this.getUserDetails.profileUrl,
        isPresenter: this.isPresenter,
        webinarId: this.webinarId
      };
      // Create a reference to the special '.info/connected' path in
      // Realtime Database. This path returns `true` when connected
      // and `false` when disconnected.
      firebase
        .database()
        .ref(".info/connected")
        .on("value", async function (snapshot) {
          // If we're not currently connected, don't do anything.
          if (snapshot.val() == false) {
            // Instead of simply returning, we'll also set Firestore's state
            // to 'offline'. This ensures that our Firestore cache is aware
            // of the switch to 'offline.'
            await userStatusFirestoreRef.get().then(docSnapShot => {
              if (docSnapShot.exists) {
                userStatusFirestoreRef.update(isOfflineForFirestore);
              } else {
                userStatusFirestoreRef.set(isOfflineForFirestore);
              }
            });
            return;
          }

          // If we are currently connected, then use the 'onDisconnect()'
          // method to add a set which will only trigger once this
          // client has disconnected by closing the app,
          // losing internet, or any other means.
          userStatusDatabaseRef
            .onDisconnect()
            .set(isOfflineForDatabase)
            .then(async function () {
              // The promise returned from .onDisconnect().set() will
              // resolve as soon as the server acknowledges the onDisconnect()
              // request, NOT once we've actually disconnected:
              // https://firebase.google.com/docs/reference/js/firebase.database.OnDisconnect

              // We can now safely set ourselves as 'online' knowing that the
              // server will mark us as offline once we lose connection.
              await userStatusDatabaseRef.set(isOnlineForDatabase);
              // We'll also add Firestore set here for when we come online.

              await userStatusFirestoreRef.get().then(docSnapShot => {
                if (docSnapShot.exists) {
                  userStatusFirestoreRef.update(isOnlineForFirestore);
                } else {
                  userStatusFirestoreRef.set(isOnlineForFirestore);
                }
              });
            });
        });

      // userStatusFirestoreRef.onSnapshot(function(doc) {
      //   var isOnline = doc.data().state == "online";
      //   // ... use isOnline
      // });
    },



    async currentActiveUsers() {
      let context = this;
      let users = [];
      try {
        firestore
          .collection("/WebinarReport/" + this.webinarId + "/Users/")
          .onSnapshot(function (snapshot) {
            snapshot.docChanges().forEach(async function (change) {
              if (change.type === "added") {
                let user = {
                  id: change.doc.id,
                  name: change.doc.data().name,
                  role: change.doc.data().role,
                  area: change.doc.data().area,
                  team: change.doc.data().team,
                  profileUrl: change.doc.data().profileUrl
                    ? change.doc.data().profileUrl
                    : require("../../../public/user.jpg"),
                  isPresenter: change.doc.data().isPresenter,
                  lastChanged: change.doc.data().last_changed,
                  lastQuestionAsked: change.doc.data().Questiondetails
                    ? change.doc.data().Questiondetails.LastQuestionAsked
                    : "",
                  IsAnswered: change.doc.data().Questiondetails
                    ? change.doc.data().Questiondetails.IsAnswered
                    : false,
                  isActive: change.doc.data().state == "online" ? true : false
                };
                users.push(user);
              }
              if (change.type === "modified") {
                let user = {
                  id: change.doc.id,
                  name: change.doc.data().name,
                  role: change.doc.data().role,
                  area: change.doc.data().area,
                  team: change.doc.data().team,
                  profileUrl: change.doc.data().profileUrl
                    ? change.doc.data().profileUrl
                    : require("../../../public/user.jpg"),
                  isPresenter: change.doc.data().isPresenter,
                  lastChanged: change.doc.data().last_changed,
                  lastQuestionAsked: change.doc.data().Questiondetails
                    ? change.doc.data().Questiondetails.LastQuestionAsked
                    : "",
                  IsAnswered: change.doc.data().Questiondetails
                    ? change.doc.data().Questiondetails.IsAnswered
                    : false,
                  isActive: change.doc.data().state == "online" ? true : false
                };
                const index = users.findIndex(x => x.id == change.doc.id);
                if (index > -1) {
                  users.splice(index, 1);
                }
                users.push(user);
              }

              if (change.type === "removed") {
                users.filter(x => x.id == change.doc.id)[0].isActive =
                  change.doc.data().state == "online" ? true : false;
              }

              var sortedUser = context.sortUser(users);
              context.activeUsers = sortedUser;
            });
          });
      } catch (error) {
        console.log(error);
      }
    },

    sortUser(users) {

      var sortedUserArray = [];
      var presenter = users.filter(x => x.isPresenter == true);
      if (presenter.length > 0) {
        sortedUserArray.push(presenter[0])
      }

      var unAnsweredUsers = users.filter(x => x.isPresenter == false && x.lastQuestionAsked && x.IsAnswered == false);
      if (unAnsweredUsers.length > 0) {
        var sortedUnanswered = unAnsweredUsers.sort((a, b) => parseInt(a.lastQuestionAsked.seconds) - parseInt(b.lastQuestionAsked.seconds)).reverse();
        sortedUserArray.push(...sortedUnanswered);
      }

      var answeredUsers = users.filter(x => x.isPresenter == false && x.lastQuestionAsked && x.IsAnswered == true);
      if (answeredUsers.length > 0) {
        var sortedAnswered = answeredUsers.sort((a, b) => parseInt(a.lastQuestionAsked.seconds) - parseInt(b.lastQuestionAsked.seconds)).reverse();
        sortedUserArray.push(...sortedAnswered);
      }

      // answered by presenter,but no question by user
      var answeredByPresenterWithoutQues = users.filter(x => x.isPresenter == false && x.lastQuestionAsked == "" && x.IsAnswered == true);
      if (answeredByPresenterWithoutQues.length > 0) {
        var sortedAnsweredByPresenterWithoutQues = answeredByPresenterWithoutQues.sort((a, b) => parseInt(a.lastChanged.seconds) - parseInt(b.lastChanged.seconds)).reverse()
        sortedUserArray.push(...sortedAnsweredByPresenterWithoutQues);
      }


      var usersWithoutQuestions = users.filter(x => x.isPresenter == false && x.lastQuestionAsked == "" && x.IsAnswered == false);
      if (usersWithoutQuestions.length > 0) {
        var sortedUsersWithoutQues = usersWithoutQuestions.sort((a, b) => parseInt(a.lastChanged.seconds) - parseInt(b.lastChanged.seconds)).reverse();

        sortedUserArray.push(...sortedUsersWithoutQues);
      }
      return sortedUserArray;
    },

    openChatPopup(userID, isPresenter) {
      if (isPresenter) {
        return false;
      }

      this.$router.app.$emit("openChatPopup", userID);
    }
  }
};
